module.exports = __webpack_public_path__ + "static/img/Next-z@2x.8de2d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Next-z@2x.png
// module id = OqqI
// module chunks = 96